import React from 'react';
import './style.less';

const source = [
    'https://oss.aircourses.com/web/client/bannerArticle/article2/img_5.png',
    'https://oss.aircourses.com/web/client/bannerArticle/article2/img_4.png',
    'https://oss.aircourses.com/web/client/bannerArticle/article2/img_11.png',
    'https://oss.aircourses.com/web/client/bannerArticle/article2/img_12.png',
    'https://oss.aircourses.com/web/client/bannerArticle/article2/img_1.png',
    'https://oss.aircourses.com/web/client/bannerArticle/article2/img_6.png',
    'https://oss.aircourses.com/web/client/bannerArticle/article2/img_13.png',
    'https://oss.aircourses.com/web/client/bannerArticle/article2/gif_1.gif',
    'https://oss.aircourses.com/web/client/bannerArticle/article2/img_14.png',
    'https://oss.aircourses.com/web/client/bannerArticle/article2/img_2.png',
    'https://oss.aircourses.com/web/client/bannerArticle/article2/img_15.png',
    'https://oss.aircourses.com/web/client/bannerArticle/article2/img_16.png',
    'https://oss.aircourses.com/web/client/bannerArticle/article2/img_7.png',
    'https://oss.aircourses.com/web/client/bannerArticle/article2/img_8.png',
    'https://oss.aircourses.com/web/client/bannerArticle/article2/img_9.png',
    'https://oss.aircourses.com/web/client/bannerArticle/article2/img_3.png',
    'https://oss.aircourses.com/web/client/bannerArticle/article2/img_10.png',
    'https://oss.aircourses.com/web/client/bannerArticle/article2/img_17.png',
    'https://oss.aircourses.com/web/client/bannerArticle/article2/img_18.png',
    'https://oss.aircourses.com/web/client/bannerArticle/article2/img_19.png',


];
export default function BannerArticlePage1() {
    return <div className="BannerArticlePage">
        <h1>哈佛外教百科英语到底优秀在哪里？</h1>
        <img className="mt35" src={source[0]} alt="爱课AirCourse" />
        <p className="mt28">如果说语言是一门工具，那么英语则是当今世界上应用最广泛的那一个。如今，让自家娃从小开始学英语的重要性，已经是老生常谈了。到底应该怎么选辅导课，怎么样的课程才是最适合自己孩子，一定是所有妈妈关心的问题。</p>
        <p>今天我们就来说说 ，哈佛外教百科英语为什么受那么多妈妈喜欢！</p>
        <img className="imgTitle mlr-auto" src={source[1]} alt="爱课AirCourse" />
        <p className="mt28">比起动辄数万的少儿英语课，AirCourse爱课《哈佛外教百科英语》的价格可以说是非常的美丽了：<em>一年365天，365个主题课，平均每节课竟然不到5块钱</em>……即便是经过重磅升级，涨价后的每节课依旧只要不到10块钱！</p>
        <p>不到10块钱，还不够买一杯奶茶，但是却能让孩子学习由哈佛外教教授的精品课程，简直不要太划算！</p>
        <p>家长们一定要想，这么便宜竟然能听到哈佛外教的课，靠谱嘛？</p>
        <img className="mt28" src={source[2]} alt="爱课AirCourse" />
        <p className="mt28"><em>AirCourse爱课是目前唯一一家直接和哈佛HSA（哈佛大学学生联盟会）合作的语培机构</em>，所有外教均由爱课与哈佛HSA联合甄选培养，素质杠杠滴~</p>
        <img className="mt28" src={source[3]} alt="爱课AirCourse" />
        <img className="imgTitle mlr-auto" src={source[4]} alt="爱课AirCourse" />
        <p className="mt28">《哈佛外教百科英语》的课程内容包括365个主题课程，涵盖生命科学、自然地理、音乐文化、哲学宗教、人文艺术等全方位的百科知识。</p>
        <img className="mt28" src={source[5]} alt="爱课AirCourse" />
        <p className="">同时，AirCourse爱课根据不同年龄段孩子认知基础、学习能力等方面不同，研发了2套课程可供家长们选择，并且可以随时切换：</p>
        <p><em>L0启蒙课：适合1年以下英语基础的宝贝学习。</em>课程知识难度相对简单，涉及简单的词汇及基础句型，让宝贝在学习英语的过程中了解世界。</p>
        <img className="mt28" src={source[6]} alt="爱课AirCourse" />
        <p className="mt28">生活化的场景及内容，更容易激发宝贝的学习兴趣，也能够让宝贝的应用能力大大提升。</p>
        <img className="mt28" src={source[7]} alt="爱课AirCourse" />
        <p className="mt28"><em>L1拓展课：适合有1-2年英语基础的宝贝学习。</em>课程涉及词汇量较大，句型丰富，比较适合已有一定英语基础的宝贝进行知识拓展。</p>
        <img className="mt28" src={source[8]} alt="爱课AirCourse" />
        <p className="mt28"><em>了解的知识越多，才能走得更远。</em>相信不少宝爸宝妈都发现了一个问题：宝贝知道熊猫的“英文名”是Panda，但却不了解熊猫的生活习性；宝贝知道了Halloween，却不了解这个节日背后的文化内涵……</p>
        <p>如果宝贝只学会了单词、句式，却不了解背后的知识，那学到的语言能力就只是停留在表层上，无法完成优秀的与世界、他人对话的能力。我们不仅要让孩子学习基本的语法，更要注重知识拓展。</p>
        <img className="imgTitle mlr-auto" src={source[9]} alt="爱课AirCourse" />
        <p className="mt28">《哈佛外教百科英语》采用<em>线上AI智能课堂+哈佛外教直播的形式授课</em>，与AI结合可能是时下最流行的英语学习方式，课程设置也是亮点颇多。</p>
        <p>在上课前，小朋友们可以自行预习课程：L0课程的预习形式是<em>绘本阅读</em>，可以根据需求选择不同的字幕；</p>
        <img className="mt28" src={source[10]} alt="爱课AirCourse" />
        <p className="mt28">L1课程的预习形式是<em>视频小课</em>，有老师演示讲解。</p>
        <img className="mt28" src={source[11]} alt="爱课AirCourse" />
        <p className="mt28"><em>每晚19:30/20:00，哈佛外教会准时进行半小时的直播教学，上课的小朋友会被智能匹配到4人小班课堂。</em>现在，小朋友们也可以自行邀请学伴组队学习。</p>
        <img className="mt28" src={source[12]} alt="爱课AirCourse" />
        <p className="mt28">课堂形式的亮点主要在于外教专业性、人机互动性强以及PK学习氛围浓厚。唱歌、拉小提琴、角色扮演……只要是与课程内容相关，能够吸引小朋友学习兴趣的，哈佛外教们都积极尝试，展现一个鲜活的老师形象。</p>
        <img className="mt28" src={source[13]} alt="爱课AirCourse" />
        <p className="mt28">AI课堂的人机互动也是十分重要的功能。课程内容中穿插游戏PK，回答问题得钻石的环节，能够激发孩子的竞争意识，上课更加专注。</p>
        <img className="mt28" src={source[14]} alt="爱课AirCourse" />
        <img className="imgTitle mlr-auto" src={source[15]} alt="爱课AirCourse" />
        <p className="mt28">2018年，爱课斩获了腾讯网颁发的“2018年度知名少儿英语品牌”、妈妈网年度口碑王奖项。</p>
        <img className="mt28" src={source[16]} alt="爱课AirCourse" />
        <p className="mt28">2019年11月，爱课斩获国家创新创业大赛全国银奖。</p>
        <img className="mt28" src={source[17]} alt="爱课AirCourse" />
        <p className="mt28">2019年12月，爱课又斩获“网易金翼奖年度家长信赖少儿英语品牌”行业大奖！</p>
        <img className="mt28" src={source[18]} alt="爱课AirCourse" />
        <p className="mt28">此外，爱课还作为全球范围内唯一受邀的少儿英语品牌赴瑞士参加了有“教育界奥林匹克”之称的2019年全球教育领袖峰会，与众多教育大牛交流合作。</p>
        <img className="mt28" src={source[19]} alt="爱课AirCourse" />
        <p className="mt28">好老师，好课程，好平台，在未来，我们还将创造更多适合中国小朋友们的优质课程！</p>

    </div>
}


// WEBPACK FOOTER //
// ./src/components/bannerArticle/page2.jsx